import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import API_PATH from "../../constants/config.json";
import Cookies from 'js-cookie';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/Info';
import { Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { Parser } from "json2csv";
import { customZip } from "../../utils/ExportShapefile";

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const useStyles = makeStyles((theme) => ({
    exportLayers: {
        position: 'absolute',
        top: '65px',
        right: '5px',
        backgroundColor: '#fff',
        width: '250px',
        border: '1px solid #24618E',
        borderRadius: '5px',
        padding: '10px',
        '& p': {
          margin: 0,
          paddingBottom: '5px',
          borderBottom: '1px solid rgb(0, 167, 93)',
          position: 'relative',
          '& label': {
            fontWeight: 'bold',
            fontSize: '14pt'
          },
          '& svg': {
            position: 'absolute',
            top: 0,
            right: 0,
            fontSize: '18px',
            cursor: 'pointer',
            color: '#24618E'
          }
        },
        '& ul': {
          maxHeight: '400px',
          overflowY: 'auto',
          listStyle: 'none',
          paddingLeft: 0,
          margin: 0,
          '& li': {
            overflow: 'hidden',
            width: '100%',
            padding: '4px 0px',
            '& label': {
                fontSize: '13pt',
            },
            '& div': {
              float: 'right',
              '& svg': {
                verticalAlign: 'middle',
                marginLeft: '8px',
                cursor: 'pointer'
              },
              '& label': {
                verticalAlign: 'middle'
              }
            }
          }
        }
    },
    selectionActions: {
        padding: '10px',
        backgroundColor: '#fff',
        width: '250px',
        position: 'absolute',
        right: '12px',
        zIndex: '1500',
        boxShadow: '5px 3px 15px #ccc',
        '& ul': {
            paddingLeft: 0,
            listStyle: 'none',
            marginBottom: 0,
            '& li': {
                fontSize: '16px',
                padding: '5px 0',
                cursor: 'pointer'
            }
        },
        '& p': {
            margin: 0,
            borderBottom: '1px solid rgb(0, 167, 93)',
            fontSize: '16px'
        },
        '& svg': {
            fontSize: '18px'
        }
    },
    layersLbl: {
        '& > div': {
            width: '20px !important',
            height: '20px !important',
            marginLeft: '15px'
        }
    },
    deletePopup: {
        '& .MuiDialogContent-root': {
            padding: '10px 15px',
        },
        '& .MuiPaper-root': {
            border: '1px solid #24618d',
            width: '525px',
        },
        '& .MuiDialogActions-root': {
            justifyContent: 'center',
            paddingTop: '30px'
        }
    },
    crossIcon: {
        color: '#24618d',
        fontSize: '20pt',
        fontFamily: 'Avenir_Black',
        fontWeight: '800',
        position: 'absolute',
        width: '40px !important',
        right: '5px',
        "&:hover": {
            // color: "#CC0000",
            cursor: 'pointer',
        }
    },
    header: {
        fontWeight: '800',
        color: '#24618d',
        fontFamily: 'Avenir_Black',
        fontSize: '18pt',
    },
    errorMsg: {
        backgroundColor: "#F2DEDE",
        border: "1px solid #CC0000",
        fontFamily: 'Avenir_Black',
        fontSize: '14pt',
        padding: '5px',
        marginBottom: '15px'
        , borderRadius: '5px'
    },
    clearBtn: {
        border: '1px solid #333',
        color: '#333',
        // fontSize: '12px',
        width: '150px',
        marginRight: '10px',
        textTransform: 'capitalize',
        padding: '3px 5px',
        lineHeight: 'normal',
        letterSpacing: '0',
        '& .MuiButton-root': {
          letterSpacing: '0',
        }
    },
}));


const ExportExternalLayers = (props) => {

    const classes = useStyles();
    const exportLayersRef = useRef();

    const [showSelActions, setShowSelActions] = useState(false);
    const [topPos, setTopPos] = useState('160px');
    const [selectedItem, setSelectedItem] = useState(null);
    const [exportInProgress, setExportInProgress] = useState(false);
    const [errorDialogue, setErrorDialogue] = React.useState(false);

    const handleCloseLayersExport = () => {
        props.setExternalLayersToExport([]);
        props.clearFilterExternalLayers();
    }

    const handleShowActions = (e, ind) => {
        setShowSelActions(true);
        let pos = exportLayersRef.current.getBoundingClientRect();
        let tmp = pos.top + (35 * (ind+2));
        setTopPos(tmp+'px');
        setSelectedItem(ind);
    }

    const handleClickAway = () => {
        setShowSelActions(false);
    }

    const handleExportOpt = async(opt) => {
        let layers = [...props.externalLayersToExport];
        let selLayer = layers[selectedItem];
        setShowSelActions(false);
        setExportInProgress(true);
        let time = new Date().getTime();
        let tmpName = selLayer.layerName.split(' ').join('_');
        let filename = `${tmpName}_features_${time}.${opt}`
        let result = "";
        if(opt === "csv") {
            result = generateCSVString(selLayer.features, selLayer.layerType);
        } else if(opt === "json") {
            result = JSON.stringify({"features": selLayer.features});
        } else if(opt === "geojson") {
            result = JSON.stringify(generateGeoJSONString(selLayer.layerType, selLayer.features));
        } else if(opt === "shape") {
            let options = {
                folder: tmpName+'_shape',
                types: {
                    point: tmpName,
                    polygon: tmpName,
                    polyline: tmpName
                }
            };
            let data = generateGeoJSONString(selLayer.layerType, selLayer.features);
            // result = shpwrite.zip(data, options);
            filename = `${tmpName}_features_${time}.zip`
            customZip(data, options, filename);
        }
        if(opt !== "shape") {
            var blob = new Blob([result]);
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        } 
        // else {
        //     let link = document.createElement('a');
        //     link.href = 'data:text/plain;base64,' + result;
        //     link.download = filename;
        //     link.click();
        // }
        setExportInProgress(false);
    }

    const handleDialogueBox = () => {
        setErrorDialogue(!errorDialogue);
    }

    const generateCSVString = (layerFeatures, layerType) => {
        let csv = [];
        layerFeatures.forEach(function(item) { 
            // adding lat and long to the attributes list for point features
            if( layerType === "point" && ((!item.attributes.Latitude && !item.attributes.Longitude) || (!item.attributes.LATITUDE && !item.attributes.LONGITUDE))) {
                item.attributes.LATITUDE = item.geometry[1];
                item.attributes.LONGITUDE = item.geometry[0];
            }
            csv.push(item.attributes); 
        });
        let opts = {};
        let Json2csvParser = new Parser(opts);
        let csvString = Json2csvParser.parse(csv);
        return csvString;
    }

    const generateGeoJSONString = (layerType, layerFeatures) => {
        let tmpType = layerType === "point" ? "Point" : (layerType === "polyline" ? "LineString" : "Polygon");
        let features = layerFeatures.map(function(item){
            let coords = [];
            if(tmpType === "Point") {
                if(item.geometry[0])
                    coords = [parseFloat(item.geometry[0]), parseFloat(item.geometry[1])]
            } else if(tmpType === "LineString") {
                if(item.geometry)
                    coords = item.geometry;
            } else if(tmpType === "Polygon") {
                if(item.geometry)
                    coords = item.geometry;
            }
            return {
                type: 'Feature',
                geometry: {
                    type: tmpType,
                    coordinates: coords
                },
                properties: item.attributes
            }
        });
        let geoJsonFile = {
            type: 'FeatureCollection',
            features: features
        };
        return geoJsonFile;
    }

    return (
        <>
        <div className={classes.exportLayers} ref={exportLayersRef} data-testid="exportLayersContainer">
            <p>
                <label className={classes.layersLbl}>Layers 
                    { exportInProgress && <CircularProgress /> }
                </label>
                <CloseIcon onClick={handleCloseLayersExport} />
            </p>
            <ul>
            {
                props.externalLayersToExport.map( (layer, ind) => {
                return <li>
                    <label>{layer.layerName}</label> 
                    <div><label>{layer.features.length}</label><MoreHorizIcon onClick={(e) => handleShowActions(e, ind)} /></div>
                    </li>
                })
            }
            </ul>
        </div>
        {
            showSelActions &&
            <ClickAwayListener onClickAway={handleClickAway}>
                <div className={classes.selectionActions} style={{top: topPos}} data-testid="actionsContainer">
                    <p>Selection Actions</p>
                    <ul>
                        <li onClick={() => handleExportOpt('csv')}><GetAppIcon /> Export to CSV file</li>
                        <li onClick={() => handleExportOpt('shape')}><GetAppIcon /> Export to shape file</li>
                        {/* <li onClick={() => handleExportOpt('json')}><GetAppIcon /> Export to feature collection</li> */}
                        <li onClick={() => handleExportOpt('geojson')}><GetAppIcon /> Export to GeoJSON</li>
                    </ul>
                </div>
            </ClickAwayListener>
        }
        <Dialog
            open={errorDialogue}
            onClose={handleDialogueBox}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.deletePopup}
        >
            <DialogTitle id="alert-dialog-title" style={{ borderBottom: "1px solid #00A75D", marginRight: '15px', marginLeft: '15px', padding: '7px 0px 0px 21px' }}>
                <Typography component={"h4"} className={classes.header} style={{ marginLeft: "-20px" }}>
                    Error
                <FontAwesomeIcon icon={faTimes} className={classes.crossIcon} onClick={handleDialogueBox} />

                </Typography>
            </DialogTitle>
            <DialogContent>
                <Typography className={classes.errorMsg} >
                    <InfoIcon style={{ color: '#CC0000', marginBottom: '-6px' }} /> File Downloading Failed!
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDialogueBox} className={classes.clearBtn} style={{ border: "1px solid #24618E", borderRadius: '5px', marginBottom: "10px" }}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
        </>
    )
}


export default ExportExternalLayers;